import { IconSvg, IconSvgProps } from "./icon"

export default function Home(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M19.857 12.36a1.14 1.14 0 0 0-.366-.846L12.43 5l-7.063 6.514A1.143 1.143 0 0 0 5 12.36v6.354a1.143 1.143 0 0 0 1.143 1.143h12.571a1.143 1.143 0 0 0 1.143-1.143V12.36Z" />
    </IconSvg>
  )
}
